import { render } from "./FourthStep.vue?vue&type=template&id=6f7f49b1"
import script from "./FourthStep.vue?vue&type=script&lang=js"
export * from "./FourthStep.vue?vue&type=script&lang=js"

import "./FourthStep.vue?vue&type=style&index=0&id=6f7f49b1&lang=scss"

import exportComponent from "D:\\Build Apps\\bestphone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__